export default __webpack_public_path__ + "static/media/logo-black-800.9552ebae.png";